import React from 'react';

import {
  convertLocationParamsToFetchParams,
  useProcesses,
} from 'app/process/api';
import {QuizGenericObjectsSidebar} from 'app/quizzes/components/QuizDetailPage/QuizGenericObjectsSidebar';
import {PROCESS_CREATE_PAGE_URL} from 'app/urls';

import type {LinkedDocumentType, QuizSerializedType} from 'sweet-types';

interface Props {
  quiz: QuizSerializedType;
  attachedItems: Array<LinkedDocumentType>;
}

export function QuizProcessesSidebar({quiz, attachedItems}: Props) {
  return (
    <QuizGenericObjectsSidebar
      quizId={quiz.id}
      quizURL={quiz.url}
      closeUrl={quiz.html_url}
      attachedItems={attachedItems}
      contentType={'proceduregroup'}
      createURL={PROCESS_CREATE_PAGE_URL}
      useDataHook={useProcesses}
      paramsConverter={convertLocationParamsToFetchParams}
      canEdit={quiz.can_edit}
    />
  );
}
